// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BtKm_sXnCPrXxHB28zQC {
  margin: 0;
  padding: 0;
}

.Kz0kG3nBu4Ffe5C_qLKm {
  color: var(--primary-font-color);
}

.LllrR1pFjchWTaVR5Xtg {
  color: var(--primary-link-color);
}

.sWwZ3qXwFrR_74eTA_nL {
  color: var(--secondary-font-color);
}

.tS5gduCeyoKvlL0Q3oQw {
  color: var(--tertiary-font-color);
}

.dt6rMcCmmUWPYKKspOxZ {
  color: var(--grey-300);
}

.vQGVSvRGoZZkW1U52mpk {
  color: var(--grey-400);
}

.PRLl2ufAeCDIILmMs6NV {
  color: var(--error-red);
}

.jObotA8AOqaiHA1kYAVH {
  color: var(--top-block-font-color);
}

.ZBdLjGQKXAgO4JZSfkOv {
  color: var(--top-block-description-font-color);
}

.LW02Mfb3dN_WKNOTIF5o {
  color: var(--accent-font-color);
}

.OzBm3NmvfCcLTvpUskvB {
  color: var(--classic-rose);
}

.NncLt9kBvLBMDiQtk9sv {
  color: var(--white);
}

.o6R0ksxZwLFoVRlJDGJ3 {
  color: var(--custom-paypal-warning-color);
}

.Asrn0QTLGwoE5LMDHRHv,
.O6vukQyegyc4j11JDclG,
.bojK7BzU7IGQqZQciQtj,
.k0xJJg49r2BUgNvcTOwG {
  font-family: var(--heading-font-family);
}

.Asrn0QTLGwoE5LMDHRHv {
  font-weight: 900;
  font-size: 4.5rem;
  line-height: 4.75rem;
}

.O6vukQyegyc4j11JDclG {
  font-weight: 900;
  font-size: 3rem;
  line-height: 3.25rem;
}

.bojK7BzU7IGQqZQciQtj {
  font-weight: var(--h3-font-weight);
  font-size: var(--h3-font-size);
  line-height: 2rem;
}

.k0xJJg49r2BUgNvcTOwG {
  font-weight: 800;
  font-size: 1.75rem;
  line-height: 2rem;
}

.JFZJ6eMUTy6M5qWZqSkN,
.yqZA8uM9NPW8tAzkxgSx,
.ldpXKsVi5Zw3QGuky2Xh,
.vPrLFePuyqk43tW7enzQ,
.PXSlUaQOBfkOt9UsDyww {
  font-family: var(--body-font-family);
}

.JFZJ6eMUTy6M5qWZqSkN {
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5rem;
}

.yqZA8uM9NPW8tAzkxgSx {
  font-weight: var(--body2-font-weight);
  font-size: 1.125rem;
  line-height: 1.5rem;
}

.ldpXKsVi5Zw3QGuky2Xh {
  font-weight: var(--bodySubText1-font-weight);
  font-size: 1rem;
  line-height: 1.375rem;
}

.vPrLFePuyqk43tW7enzQ {
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.375rem;
}

.PXSlUaQOBfkOt9UsDyww {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.vg6l3pCkRmVahpsskYop {
  white-space: unset;
  -webkit-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .Asrn0QTLGwoE5LMDHRHv {
    font-weight: 900;
    font-size: 3rem;
    line-height: 3.25rem;
  }

  .O6vukQyegyc4j11JDclG {
    font-weight: 900;
    font-size: 2.375rem;
    line-height: 2.625rem;
  }

  .bojK7BzU7IGQqZQciQtj {
    font-weight: var(--h3-font-weight);
    font-size: 2rem;
    line-height: 2.25rem;
  }

  .k0xJJg49r2BUgNvcTOwG {
    font-weight: 800;
    font-size: 1.75rem;
    line-height: 2rem;
  }

  .JFZJ6eMUTy6M5qWZqSkN {
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

  .yqZA8uM9NPW8tAzkxgSx {
    font-weight: var(--body2-font-weight);
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .Asrn0QTLGwoE5LMDHRHv {
    font-weight: 900;
    font-size: 2rem;
    line-height: 2.375rem;
  }

  .O6vukQyegyc4j11JDclG {
    font-weight: 900;
    font-size: 1.75rem;
    line-height: 2rem;
  }

  .bojK7BzU7IGQqZQciQtj {
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .k0xJJg49r2BUgNvcTOwG {
    font-weight: 800;
    font-size: 1.0625rem;
    line-height: 1.3125rem;
  }

  .JFZJ6eMUTy6M5qWZqSkN {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .yqZA8uM9NPW8tAzkxgSx {
    font-weight: var(--body2-font-weight);
    font-size: 1rem;
    line-height: 1.375rem;
  }

  .ldpXKsVi5Zw3QGuky2Xh {
    font-weight: var(--bodySubText1-font-weight);
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .vPrLFePuyqk43tW7enzQ {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.KW9EZdCcgfC3sBZlUSbm.Asrn0QTLGwoE5LMDHRHv {
    font-weight: 900;
    font-size: 4.5rem;
    line-height: 4.75rem;
  }

.KW9EZdCcgfC3sBZlUSbm.O6vukQyegyc4j11JDclG {
    font-weight: 900;
    font-size: 3rem;
    line-height: 3.25rem;
  }

.KW9EZdCcgfC3sBZlUSbm.bojK7BzU7IGQqZQciQtj {
    font-weight: var(--h3-font-weight);
    font-size: var(--h3-font-size);
    line-height: 2rem;
  }

.KW9EZdCcgfC3sBZlUSbm.k0xJJg49r2BUgNvcTOwG {
    font-weight: 800;
    font-size: 1.75rem;
    line-height: 2rem;
  }

.KW9EZdCcgfC3sBZlUSbm.JFZJ6eMUTy6M5qWZqSkN {
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

.KW9EZdCcgfC3sBZlUSbm.yqZA8uM9NPW8tAzkxgSx {
    font-weight: var(--body2-font-weight);
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

.KW9EZdCcgfC3sBZlUSbm.ldpXKsVi5Zw3QGuky2Xh {
    font-weight: var(--bodySubText1-font-weight);
    font-size: 1rem;
    line-height: 1.375rem;
  }

.KW9EZdCcgfC3sBZlUSbm.vPrLFePuyqk43tW7enzQ {
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.375rem;
  }

.KW9EZdCcgfC3sBZlUSbm.PXSlUaQOBfkOt9UsDyww {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

.TWmMQ9_59RTLYpS247Fm.Asrn0QTLGwoE5LMDHRHv {
    font-weight: 900;
    font-size: 3rem;
    line-height: 3.25rem;
  }

.TWmMQ9_59RTLYpS247Fm.O6vukQyegyc4j11JDclG {
    font-weight: 900;
    font-size: 2.375rem;
    line-height: 2.625rem;
  }

.TWmMQ9_59RTLYpS247Fm.bojK7BzU7IGQqZQciQtj {
    font-weight: var(--h3-font-weight);
    font-size: var(--h3-font-size);
    line-height: 2rem;
  }

.TWmMQ9_59RTLYpS247Fm.k0xJJg49r2BUgNvcTOwG {
    font-weight: 800;
    font-size: 1.75rem;
    line-height: 2rem;
  }

.TWmMQ9_59RTLYpS247Fm.JFZJ6eMUTy6M5qWZqSkN {
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

.TWmMQ9_59RTLYpS247Fm.yqZA8uM9NPW8tAzkxgSx {
    font-weight: var(--body2-font-weight);
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

.rDVh1jLj1nZeah91g9V6.Asrn0QTLGwoE5LMDHRHv {
    font-weight: 900;
    font-size: 2rem;
    line-height: 2.375rem;
  }

.rDVh1jLj1nZeah91g9V6.O6vukQyegyc4j11JDclG {
    font-weight: 900;
    font-size: 1.75rem;
    line-height: 2rem;
  }

.rDVh1jLj1nZeah91g9V6.bojK7BzU7IGQqZQciQtj {
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

.rDVh1jLj1nZeah91g9V6.k0xJJg49r2BUgNvcTOwG {
    font-weight: 800;
    font-size: 1.0625rem;
    line-height: 1.3125rem;
  }

.rDVh1jLj1nZeah91g9V6.JFZJ6eMUTy6M5qWZqSkN {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.375rem;
  }

.rDVh1jLj1nZeah91g9V6.yqZA8uM9NPW8tAzkxgSx {
    font-weight: var(--body2-font-weight);
    font-size: 1rem;
    line-height: 1.375rem;
  }

.rDVh1jLj1nZeah91g9V6.ldpXKsVi5Zw3QGuky2Xh {
    font-weight: var(--bodySubText1-font-weight);
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

.rDVh1jLj1nZeah91g9V6.vPrLFePuyqk43tW7enzQ {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Typography/Typography.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,iBAAe;EACf,oBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAe;EACf,mBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,mBAAe;EACf,mBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,qBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAe;EACf,mBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAa;UAAb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,mBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,mBAAe;IACf,mBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,oBAAe;IACf,sBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,eAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,4CAA4C;IAC5C,mBAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,oBAAiB;EACnB;AACF;;AAGE;IACE,gBAAgB;IAChB,iBAAe;IACf,oBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAiB;EACnB;;AAEA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,mBAAiB;EACnB;;AAEA;IACE,qCAAqC;IACrC,mBAAe;IACf,mBAAiB;EACnB;;AAEA;IACE,4CAA4C;IAC5C,eAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,mBAAiB;EACnB;;AAIA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,mBAAiB;EACnB;;AAEA;IACE,qCAAqC;IACrC,mBAAe;IACf,mBAAiB;EACnB;;AAIA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,iBAAe;IACf,oBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,oBAAe;IACf,sBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,qCAAqC;IACrC,eAAe;IACf,qBAAiB;EACnB;;AAEA;IACE,4CAA4C;IAC5C,mBAAe;IACf,oBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,mBAAe;IACf,oBAAiB;EACnB","sourcesContent":[".root {\n  margin: 0;\n  padding: 0;\n}\n\n.primary {\n  color: var(--primary-font-color);\n}\n\n.linkPrimary {\n  color: var(--primary-link-color);\n}\n\n.secondary {\n  color: var(--secondary-font-color);\n}\n\n.tertiary {\n  color: var(--tertiary-font-color);\n}\n\n.quaternary {\n  color: var(--grey-300);\n}\n\n.quinary {\n  color: var(--grey-400);\n}\n\n.error {\n  color: var(--error-red);\n}\n\n.topBlock {\n  color: var(--top-block-font-color);\n}\n\n.topBlockDescription {\n  color: var(--top-block-description-font-color);\n}\n\n.accent {\n  color: var(--accent-font-color);\n}\n\n.pink {\n  color: var(--classic-rose);\n}\n\n.white {\n  color: var(--white);\n}\n\n.warning {\n  color: var(--custom-paypal-warning-color);\n}\n\n.h1,\n.h2,\n.h3,\n.h4 {\n  font-family: var(--heading-font-family);\n}\n\n.h1 {\n  font-weight: 900;\n  font-size: 72px;\n  line-height: 76px;\n}\n\n.h2 {\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 52px;\n}\n\n.h3 {\n  font-weight: var(--h3-font-weight);\n  font-size: var(--h3-font-size);\n  line-height: 32px;\n}\n\n.h4 {\n  font-weight: 800;\n  font-size: 28px;\n  line-height: 32px;\n}\n\n.body1,\n.body2,\n.bodySubText1,\n.bodySubText2,\n.subText1 {\n  font-family: var(--body-font-family);\n}\n\n.body1 {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.body2 {\n  font-weight: var(--body2-font-weight);\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.bodySubText1 {\n  font-weight: var(--bodySubText1-font-weight);\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.bodySubText2 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.subText1 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.noWrap {\n  white-space: unset;\n  hyphens: auto;\n  word-break: break-word;\n}\n\n@media (--tablet) {\n  .h1 {\n    font-weight: 900;\n    font-size: 48px;\n    line-height: 52px;\n  }\n\n  .h2 {\n    font-weight: 900;\n    font-size: 38px;\n    line-height: 42px;\n  }\n\n  .h3 {\n    font-weight: var(--h3-font-weight);\n    font-size: 32px;\n    line-height: 36px;\n  }\n\n  .h4 {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  .body1 {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .body2 {\n    font-weight: var(--body2-font-weight);\n    font-size: 18px;\n    line-height: 24px;\n  }\n}\n\n@media (--mobile) {\n  .h1 {\n    font-weight: 900;\n    font-size: 32px;\n    line-height: 38px;\n  }\n\n  .h2 {\n    font-weight: 900;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  .h3 {\n    font-weight: 900;\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .h4 {\n    font-weight: 800;\n    font-size: 17px;\n    line-height: 21px;\n  }\n\n  .body1 {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .body2 {\n    font-weight: var(--body2-font-weight);\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .bodySubText1 {\n    font-weight: var(--bodySubText1-font-weight);\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .bodySubText2 {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n\n.l {\n  &.h1 {\n    font-weight: 900;\n    font-size: 72px;\n    line-height: 76px;\n  }\n\n  &.h2 {\n    font-weight: 900;\n    font-size: 48px;\n    line-height: 52px;\n  }\n\n  &.h3 {\n    font-weight: var(--h3-font-weight);\n    font-size: var(--h3-font-size);\n    line-height: 32px;\n  }\n\n  &.h4 {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  &.body1 {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  &.body2 {\n    font-weight: var(--body2-font-weight);\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  &.bodySubText1 {\n    font-weight: var(--bodySubText1-font-weight);\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  &.bodySubText2 {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  &.subText1 {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n.m {\n  &.h1 {\n    font-weight: 900;\n    font-size: 48px;\n    line-height: 52px;\n  }\n\n  &.h2 {\n    font-weight: 900;\n    font-size: 38px;\n    line-height: 42px;\n  }\n\n  &.h3 {\n    font-weight: var(--h3-font-weight);\n    font-size: var(--h3-font-size);\n    line-height: 32px;\n  }\n\n  &.h4 {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  &.body1 {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  &.body2 {\n    font-weight: var(--body2-font-weight);\n    font-size: 18px;\n    line-height: 24px;\n  }\n}\n\n.s {\n  &.h1 {\n    font-weight: 900;\n    font-size: 32px;\n    line-height: 38px;\n  }\n\n  &.h2 {\n    font-weight: 900;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  &.h3 {\n    font-weight: 900;\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  &.h4 {\n    font-weight: 800;\n    font-size: 17px;\n    line-height: 21px;\n  }\n\n  &.body1 {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  &.body2 {\n    font-weight: var(--body2-font-weight);\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  &.bodySubText1 {\n    font-weight: var(--bodySubText1-font-weight);\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  &.bodySubText2 {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BtKm_sXnCPrXxHB28zQC`,
	"primary": `Kz0kG3nBu4Ffe5C_qLKm`,
	"linkPrimary": `LllrR1pFjchWTaVR5Xtg`,
	"secondary": `sWwZ3qXwFrR_74eTA_nL`,
	"tertiary": `tS5gduCeyoKvlL0Q3oQw`,
	"quaternary": `dt6rMcCmmUWPYKKspOxZ`,
	"quinary": `vQGVSvRGoZZkW1U52mpk`,
	"error": `PRLl2ufAeCDIILmMs6NV`,
	"topBlock": `jObotA8AOqaiHA1kYAVH`,
	"topBlockDescription": `ZBdLjGQKXAgO4JZSfkOv`,
	"accent": `LW02Mfb3dN_WKNOTIF5o`,
	"pink": `OzBm3NmvfCcLTvpUskvB`,
	"white": `NncLt9kBvLBMDiQtk9sv`,
	"warning": `o6R0ksxZwLFoVRlJDGJ3`,
	"h1": `Asrn0QTLGwoE5LMDHRHv`,
	"h2": `O6vukQyegyc4j11JDclG`,
	"h3": `bojK7BzU7IGQqZQciQtj`,
	"h4": `k0xJJg49r2BUgNvcTOwG`,
	"body1": `JFZJ6eMUTy6M5qWZqSkN`,
	"body2": `yqZA8uM9NPW8tAzkxgSx`,
	"bodySubText1": `ldpXKsVi5Zw3QGuky2Xh`,
	"bodySubText2": `vPrLFePuyqk43tW7enzQ`,
	"subText1": `PXSlUaQOBfkOt9UsDyww`,
	"noWrap": `vg6l3pCkRmVahpsskYop`,
	"l": `KW9EZdCcgfC3sBZlUSbm`,
	"m": `TWmMQ9_59RTLYpS247Fm`,
	"s": `rDVh1jLj1nZeah91g9V6`
};
export default ___CSS_LOADER_EXPORT___;
